import { CALL_CHECK_LOADS_BUILD as actionTypes } from '../../actions/callCheckLoadsActions/callCheckLoadsActionTypes';
import * as callCheckLoads from './callCheckLoadsReducer';
import * as callCheckLoadsDetails from './callCheckLoadsDetailsReducer';

const defaultState = {
  headers: [
    {
      key: 'flag',
      title: '',
      width: 20,
      leftAction: false,
      visible: true,
    },
    {
      key: 'number',
      title: '',
      width: 20,
      leftAction: false,
      visible: true,
    },
    {
      key: 'loadNumber',
      title: 'Load #',
      width: 60,
      leftAction: false,
      visible: true,
    },
    {
      key: 'status',
      title: 'Status',
      width: 60,
      leftAction: false,
      visible: true,
    },
    {
      key: 'notes',
      title: 'Note',
      width: 25,
      leftAction: false,
      visible: true,
    },
    {
      key: 'pickAppointment',
      title: 'APPT',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'checkIn',
      title: 'Check IN',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'checkOut',
      title: 'Check OUT',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'warehouses',
      title: 'Warehouses',
      width: 100,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'sequence',
      title: 'Seq',
      width: 30,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'actions',
      title: '',
      width: 55,
      leftAction: false,
      visible: true,
    },
  ],
  detailsPageHeadersPick: [
      {
      key: 'leftAction',
      title: '',
      width: 20,
      leftAction: true,
      visible: true
    },
    {
      key: 'status',
      title: 'Status',
      width: 60,
      leftAction: false,
      visible: true,
    },
    {
      key: 'notes',
      title: 'Note',
      width: 25,
      leftAction: false,
      visible: true,
    },
    {
      key: 'appointment',
      title: 'APPT',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'pickIn',
      title: 'Pick IN',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'pickOut',
      title: 'Pick OUT',
      width: 75,
      visible: true,
    },
    {
      key: 'puDate',
      title: 'PU date',
      width: 45,
      visible: true,
    },
    {
      key: 'dueDate',
      title: 'Due date',
      width: 45,
      visible: true,
    },
    {
      key: 'deliverDate',
      title: 'D/L date',
      width: 45,
      visible: true,
    },
    {
      key: 'customer',
      title: 'Cust',
      width: 50,
      visible: true,
    },
    {
      key: 'locationName',
      title: 'Pick Location',
      width: 90,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'poNumber',
      title: 'PO#',
      width: 35,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'soNumber',
      title: 'SO#',
      width: 35,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'palletCount',
      title: 'Pal',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'space',
      title: 'S',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'cases',
      title: 'Cs',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'weight',
      title: 'LBS',
      width: 30,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'sequence',
      title: 'Seq',
      width: 40,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'temperatureName',
      title: 'Temp',
      width: 35,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'temperatureDegre',
      title: 'Tp',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'action',
      title: '',
      width: 20,
      leftAction: false,
      visible: true,
    },
  ],
  detailsPageHeadersDrop: [
      {
      key: 'leftAction',
      title: '',
      width: 20,
      leftAction: true,
      visible: true
    },
    {
      key: 'status',
      title: 'Status',
      width: 60,
      leftAction: false,
      visible: true,
    },
    {
      key: 'notes',
      title: 'Note',
      width: 25,
      leftAction: false,
      visible: true,
    },
    {
      key: 'appointment',
      title: 'APPT',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'dropIn',
      title: 'Drop IN',
      width: 75,
      leftAction: false,
      visible: true,
    },
    {
      key: 'dropOut',
      title: 'Drop OUT',
      width: 75,
      visible: true,
    },
    {
      key: 'puDate',
      title: 'PU date',
      width: 45,
      visible: true,
    },
    {
      key: 'dueDate',
      title: 'Due date',
      width: 45,
      visible: true,
    },
    {
      key: 'deliverDate',
      title: 'D/L date',
      width: 45,
      visible: true,
    },
    {
      key: 'customer',
      title: 'Cust',
      width: 50,
      visible: true,
    },
    {
      key: 'locationName',
      title: 'Drop Location',
      width: 90,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'poNumber',
      title: 'PO#',
      width: 35,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'soNumber',
      title: 'SO#',
      width: 35,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'palletCount',
      title: 'Pal',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'space',
      title: 'S',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'cases',
      title: 'Cs',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'weight',
      title: 'LBS',
      width: 30,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'sequence',
      title: 'Seq',
      width: 40,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'temperatureName',
      title: 'Temp',
      width: 35,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'temperatureDegre',
      title: 'Tp',
      width: 20,
      leftAction: false,
      rightAction: false,
      visible: true,
    },
    {
      key: 'action',
      title: '',
      width: 20,
      leftAction: false,
      visible: true,
    },
  ],
  stops: null,
  loads: null,
  loadsAssignedStops: null,
  loadNotes: null,
  stopNotes: null,
  orderNotes: null,
  notesLoading: null,
  loading: true,
  loadDetailsLoading: false,
  hasError: false,
  message: '',
  total: null,
  filterOptions: {
    pickAppointment: null,
    dropAppointment: null,
    loadType: null,
    state: null,
    region: null,
    carrier: null,
    mcNumber: null,
    dotNumber: null,
    searchText: null,
  },
  pagination: {
    page: 1,
    pageSize: 4,
  },
  loadDetails: {
    carrierEmail: null,
    carrierName: null,
    changeOrderPoNumbers: null,
    dot: null,
    driverEmail: null,
    driverName: null,
    driverPhone: null,
    dropStop: [],
    dropStopStatus: null,
    efsAmount: null,
    hasError: false,
    loadDropStopCommentsCount: null,
    loadId: null,
    loadNumber: null,
    loadPickStopCommentsCount: null,
    loadType: null,
    mc: null,
    message: null,
    pickStop: [],
    pickStopStatus: null,
    scaleTicket: null,
  },
  EFSLoading: false,
  EFSList: null,
  EFS: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.GET_CALL_CHECK_LOADS:
      return callCheckLoads.loadContent(state, action.data);
    case actionTypes.CALL_CHECK_LOADS_ERROR:
      return callCheckLoads.setError(state, action.data);
    case actionTypes.RESET_ERROR:
      return callCheckLoads.resetError(state);
    case actionTypes.FILTER_CALL_CHECK_LOADS:
      return callCheckLoads.filterCallCheckLoads(state, action.data);
    case actionTypes.CALL_CHECK_LOADS_PAGINATION:
      return callCheckLoads.callCheckLoadsPagination(state, action.data);
    case actionTypes.GET_CALL_CHECK_LOADS_LOADING:
      return callCheckLoads.setInLoading(state);
    case actionTypes.GET_CALL_CHECK_LOADS_LOAD_NOTES_LOADING:
      return callCheckLoads.setInLoadingNotes(state);
    case actionTypes.GET_CALL_CHECK_LOADS_LOAD_NOTES:
      return callCheckLoads.getLoadNotes(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_LOAD_NOTE_LOADING:
      return callCheckLoads.setInLoadingNotes(state);
    case actionTypes.GET_CALL_CHECK_LOADS_STOP_NOTES_LOADING:
      return callCheckLoads.setInLoadingNotes(state);
    case actionTypes.GET_CALL_CHECK_LOADS_STOP_NOTES:
      return callCheckLoads.getStopNotes(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_STOP_NOTE_LOADING:
      return callCheckLoads.setInLoadingNotes(state);
    case actionTypes.SET_CALL_CHECK_LOADS_CURRENT_USER_LOADING:
      return callCheckLoads.setInLoadingCurrentUser(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_CURRENT_USER:
      return callCheckLoads.setCurrentUser(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_STOPS_STATUS_DATA:
      return callCheckLoads.setCallCheckLoadStopsStatus(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_LOADS_STATUS_DATA:
      return callCheckLoads.setCallCheckLoadLoadsStatus(state, action.data);
    case actionTypes.SET_HEADER_WIDTH_CALL_CHECK_LOADS:
      return callCheckLoads.setHeaderWidth(state, action.data.ind, action.data.width);
    case actionTypes.SET_CALL_CHECK_LOADS_STOPS_DATE:
      return callCheckLoads.setCallCheckLoadsStopSDate(state, action.data);
    case actionTypes.SET_CALL_CHECK_ALL_NOTES_EMPTY:
      return callCheckLoads.setEmptyAllNotes(state, action.data);


    case actionTypes.SET_CALL_CHECK_LOADS_ORDER_DELIVER_DATE_DETAILS:
      return callCheckLoadsDetails.setCallCheckLoadsOrderDeliverDateDetails(state, action.data); 
    case actionTypes.SET_CALL_CHECK_LOADS_STOPS_DATE_DETAILS:
      return callCheckLoadsDetails.setCallCheckLoadsStopSDateDetails(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_STOP_NOTE:
      return callCheckLoadsDetails.setStopNotes(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_LOAD_NOTE:
      return callCheckLoadsDetails.setLoadNotes(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_STOPS_DETAILS_STATUS_DATA:
      return callCheckLoadsDetails.setCallCheckLoadStopsStatus(state, action.data);
    case actionTypes.GET_CALL_CHECK_LOAD_DETAILS_LOADING:
      return callCheckLoadsDetails.setInLoadingLoadDetails(state);
    case actionTypes.SET_HEADER_WIDTH_CALL_CHECK_LOADS_DETAILS:
      return callCheckLoadsDetails.setHeaderWidthLoadDetails(state, action.data.ind, action.data.width, action.data.type);
    case actionTypes.GET_CALL_CHECK_LOAD_DETAILS:
      return callCheckLoadsDetails.getLoadDetails(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_LOADS_DETAILS:
      return callCheckLoadsDetails.setLoadDetails(state, action.data);


    case actionTypes.GET_CALL_CHECK_LOADS_ORDER_NOTES:
      return callCheckLoadsDetails.getOrderNotes(state, action.data);
    case actionTypes.GET_CALL_CHECK_LOADS_ORDER_NOTES_LOADING:
      return callCheckLoads.setInLoadingNotes(state);
    case actionTypes.GET_CALL_CHECK_LOADS_ORDER_NOTES_ERROR:
      return callCheckLoads.setError(state);
    case actionTypes.SET_CALL_CHECK_LOADS_ORDER_NOTE:
      return callCheckLoadsDetails.setOrderNote(state, action.data);
    case actionTypes.SET_CALL_CHECK_LOADS_ORDER_NOTE_LOADING:
      return callCheckLoads.setInLoadingNotes(state);

    case actionTypes.REACT_ITEM:
      return callCheckLoadsDetails.reactOnItem(state, action.data.type, action.data.id);
    case actionTypes.EMPTY_EFS_LOADING:
        return callCheckLoadsDetails.setEFSLoading(state);
    case actionTypes.GET_EMPTY_EFS:
        return callCheckLoadsDetails.getEmptyEFS(state, action.data);
    case actionTypes.EFS_LIST_LOADING:
        return callCheckLoadsDetails.setEFSLoading(state);
    case actionTypes.GET_EFS:
        return callCheckLoadsDetails.getEFS(state, action.data);
    case actionTypes.GET_EFS_LOADING:
        return callCheckLoadsDetails.setEFSLoading(state);
    case actionTypes.GET_EFS_LIST:
        return callCheckLoadsDetails.getEFSList(state, action.data);
    case actionTypes.SET_EFS_LOADING:
        return callCheckLoadsDetails.setEFSLoading(state);
    case actionTypes.SET_EFS:
        return callCheckLoadsDetails.setEFS(state, action.data);
    case actionTypes.UPDATE_EFS_LOADING:
        return callCheckLoadsDetails.setEFSLoading(state);
    case actionTypes.UPDATE_EFS:
        return callCheckLoadsDetails.updateEFS(state, action.data);
    // case callCheckLoadsDetails.UPDATE_EFS_ERROR:
    //     return callCheckLoadsDetails.setError(state, action.data);
    // case actionTypes.EMPTY_EFS_ERROR:
    //     return callCheckLoadsDetails.setError(state, action.data);
    // case actionTypes.GET_EFS_ERROR:
    //     return callCheckLoadsDetails.setError(state, action.data);
    default:
      return state;
  }
};
